//# sourceMappingURL=ai_search.mjs.map
/// <reference types="./ai_search.d.mts" />
import * as $weaviate from "../../../data_types/data/weaviate.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $dropdown from "../../../ds/ds/components/dropdown.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $icons from "../../../ds/ds/icons.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $compose from "../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $requests from "../../admin/requests/ai_search.mjs";
import * as $card from "../../components/card.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList, Empty as $Empty, CustomType as $CustomType } from "../../gleam.mjs";
import * as $cl_common from "../../view/content_library/ingestion_control/common.mjs";
import * as $common from "../../view/organization/common.mjs";

export class CollectionView extends $CustomType {}
export const SearchKind$CollectionView = () => new CollectionView();
export const SearchKind$isCollectionView = (value) =>
  value instanceof CollectionView;

export class SimpleSearch extends $CustomType {}
export const SearchKind$SimpleSearch = () => new SimpleSearch();
export const SearchKind$isSimpleSearch = (value) =>
  value instanceof SimpleSearch;

function display_search_results(results) {
  let nb_results = $list.length(results);
  let _pipe = $list.index_map(
    results,
    (result, index) => {
      let search_result = result[0];
      let score = result[1];
      return $card.card(
        toList([]),
        toList([
          $card.body(
            toList([]),
            toList([
              (() => {
                if (search_result instanceof $requests.DataPointResult) {
                  let dp = search_result[0];
                  return $cl_common.display_data_point(dp);
                } else {
                  let ds = search_result[0];
                  return $cl_common.display_data_source(ds);
                }
              })(),
            ]),
          ),
          $card.footer(
            toList([]),
            toList([
              $l.row(
                toList([$l.justify("space-between")]),
                toList([]),
                toList([
                  $typography.text(
                    $typography.sm,
                    $typography.medium,
                    "Result n: " + $int.to_string(index),
                  ),
                  $typography.text(
                    $typography.sm,
                    $typography.medium,
                    "Score: " + $float.to_string(score),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
  return $list.prepend(
    _pipe,
    $typography.text(
      $typography.sm,
      $typography.medium,
      $int.to_string(nb_results) + " search results",
    ),
  );
}

function simple_search_view() {
  return $redraw.component_(
    "AiSearch(SimpleSearch)",
    (_use0) => {
      let org_id = _use0[0];
      let collection_kind = _use0[1];
      let variant = _use0[2];
      let store = $store.use_state();
      let $ = $redraw.use_state("");
      let query = $[0];
      let set_query = $[1];
      let $1 = $redraw.use_state(new Error(undefined));
      let response = $1[0];
      let set_response = $1[1];
      let submit = () => {
        return $function.tap(
          undefined,
          (_) => {
            let req = $requests.query_search(
              store,
              org_id,
              collection_kind,
              variant,
              query,
            );
            return $promise.map(
              req,
              (result) => {
                set_response(result);
                return undefined;
              },
            );
          },
        );
      };
      return $l.column(
        toList([$l.gap(16)]),
        toList([]),
        toList([
          $input.input(
            (() => {
              let _pipe = $input.value(query);
              let _pipe$1 = $input.multiline(_pipe, true);
              let _pipe$2 = $input.placeholder(
                _pipe$1,
                "Ask steerlab a question…",
              );
              let _pipe$3 = $input.icon(_pipe$2, $icons.paper_plane());
              let _pipe$4 = $input.on_input(_pipe$3, set_query);
              return $input.on_submit(_pipe$4, submit);
            })(),
          ),
          $l.column(
            toList([$l.gap(16)]),
            toList([]),
            (() => {
              if (response instanceof Ok) {
                let $2 = response[0];
                if ($2 instanceof $Empty) {
                  return toList([
                    $typography.text(
                      $typography.sm,
                      $typography.regular,
                      "No results found.",
                    ),
                  ]);
                } else {
                  let results = $2;
                  return display_search_results(results);
                }
              } else {
                return toList([]);
              }
            })(),
          ),
        ]),
      );
    },
  );
}

function collection_view() {
  return $redraw.component_(
    "AiSearch(CollectionView)",
    (_use0) => {
      let org_id = _use0[0];
      let collection_kind = _use0[1];
      let variant = _use0[2];
      let store = $store.use_state();
      let $ = $redraw.use_state(500);
      let nb_objects = $[0];
      let set_nb_objects = $[1];
      let $1 = $redraw.use_state(new Error(undefined));
      let response = $1[0];
      let set_response = $1[1];
      let submit = () => {
        return $function.tap(
          undefined,
          (_) => {
            let req = $requests.list_n_objects(
              store,
              org_id,
              collection_kind,
              variant,
              nb_objects,
            );
            return $promise.map(
              req,
              (result) => {
                set_response(result);
                return undefined;
              },
            );
          },
        );
      };
      return $l.column(
        toList([$l.gap(16)]),
        toList([]),
        toList([
          $l.row(
            toList([$l.gap(16), $l.align("end")]),
            toList([]),
            toList([
              $l.column(
                toList([]),
                toList([]),
                toList([
                  $typography.text(
                    $typography.sm,
                    $typography.medium,
                    "Number of results",
                  ),
                  $input.input(
                    (() => {
                      let _pipe = $input.value($int.to_string(nb_objects));
                      let _pipe$1 = $input.placeholder(_pipe, "Nb objects");
                      return $input.on_input(
                        _pipe$1,
                        (value) => {
                          let _pipe$2 = value;
                          let _pipe$3 = $int.parse(_pipe$2);
                          let _pipe$4 = $result.unwrap(_pipe$3, 0);
                          return set_nb_objects(_pipe$4);
                        },
                      );
                    })(),
                  ),
                ]),
              ),
              $button.primary(
                toList([$e.on_click((_) => { return submit(); })]),
                toList([$h.text("Search")]),
              ),
            ]),
          ),
          $l.column(
            toList([$l.gap(16)]),
            toList([]),
            (() => {
              if (response instanceof Ok) {
                let results = response[0];
                return display_search_results(results);
              } else {
                return toList([]);
              }
            })(),
          ),
        ]),
      );
    },
  );
}

export function view() {
  return $compose.children(
    $dropdown.dropdown(),
    (search_kind_dropdown) => {
      return $compose.children(
        $dropdown.dropdown(),
        (collection_kind_dropdown) => {
          return $compose.children(
            $dropdown.dropdown(),
            (variant_kind_dropdown) => {
              return $redraw.compose(
                collection_view(),
                (collection_view) => {
                  return $redraw.compose(
                    simple_search_view(),
                    (simple_search) => {
                      return $redraw.component_(
                        "AiSearch",
                        (_) => {
                          let $ = $redraw.use_state(
                            new $option.Some(new CollectionView()),
                          );
                          let search_kind = $[0];
                          let set_search_kind = $[1];
                          let $1 = $redraw.use_state(
                            new $option.Some(new $weaviate.Chunk()),
                          );
                          let collection_kind = $1[0];
                          let set_collection_kind = $1[1];
                          let $2 = $redraw.use_state(
                            new $option.Some(new $weaviate.Base()),
                          );
                          let variant = $2[0];
                          let set_variant = $2[1];
                          let store = $store.use_state();
                          let org_id = store.organization;
                          return $l.column(
                            toList([$l.gap(8), $l.flex("1")]),
                            toList([]),
                            toList([
                              $l.row(
                                toList([$l.gap(16), $l.align("end")]),
                                toList([]),
                                toList([
                                  $l.column(
                                    toList([]),
                                    toList([]),
                                    toList([
                                      $typography.text(
                                        $typography.sm,
                                        $typography.medium,
                                        "Search kind",
                                      ),
                                      (() => {
                                        let _pipe = $dropdown.on_selected(
                                          (v) => { return set_search_kind(v); },
                                        );
                                        let _pipe$1 = $dropdown.placeholder(
                                          _pipe,
                                          "Kind",
                                        );
                                        let _pipe$2 = $dropdown.selected(
                                          _pipe$1,
                                          search_kind,
                                        );
                                        return search_kind_dropdown(
                                          _pipe$2,
                                          toList([
                                            $dropdown.choice(
                                              "List all",
                                              new CollectionView(),
                                            ),
                                            $dropdown.choice(
                                              "Vector search",
                                              new SimpleSearch(),
                                            ),
                                          ]),
                                        );
                                      })(),
                                    ]),
                                  ),
                                  $l.column(
                                    toList([]),
                                    toList([]),
                                    toList([
                                      $typography.text(
                                        $typography.sm,
                                        $typography.medium,
                                        "Collection kind",
                                      ),
                                      (() => {
                                        let _pipe = $dropdown.on_selected(
                                          (v) => {
                                            return set_collection_kind(v);
                                          },
                                        );
                                        let _pipe$1 = $dropdown.placeholder(
                                          _pipe,
                                          "Kind",
                                        );
                                        let _pipe$2 = $dropdown.selected(
                                          _pipe$1,
                                          collection_kind,
                                        );
                                        return collection_kind_dropdown(
                                          _pipe$2,
                                          $common.collection_kind_choices(),
                                        );
                                      })(),
                                    ]),
                                  ),
                                  $l.column(
                                    toList([]),
                                    toList([]),
                                    toList([
                                      $typography.text(
                                        $typography.sm,
                                        $typography.medium,
                                        "Variant",
                                      ),
                                      (() => {
                                        let _pipe = $dropdown.on_selected(
                                          (v) => { return set_variant(v); },
                                        );
                                        let _pipe$1 = $dropdown.placeholder(
                                          _pipe,
                                          "Kind",
                                        );
                                        let _pipe$2 = $dropdown.selected(
                                          _pipe$1,
                                          variant,
                                        );
                                        return variant_kind_dropdown(
                                          _pipe$2,
                                          $common.variant_choices(),
                                        );
                                      })(),
                                    ]),
                                  ),
                                ]),
                              ),
                              (() => {
                                if (
                                  search_kind instanceof $option.Some &&
                                  org_id instanceof $option.Some &&
                                  collection_kind instanceof $option.Some &&
                                  variant instanceof $option.Some
                                ) {
                                  let $3 = search_kind[0];
                                  if ($3 instanceof CollectionView) {
                                    let org_id$1 = org_id[0];
                                    let collection_kind$1 = collection_kind[0];
                                    let variant$1 = variant[0];
                                    return collection_view(
                                      [org_id$1, collection_kind$1, variant$1],
                                    );
                                  } else {
                                    let org_id$1 = org_id[0];
                                    let collection_kind$1 = collection_kind[0];
                                    let variant$1 = variant[0];
                                    return simple_search(
                                      [org_id$1, collection_kind$1, variant$1],
                                    );
                                  }
                                } else {
                                  return $h.none();
                                }
                              })(),
                            ]),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
